export default __webpack_public_path__ + "static/media/back.223607c9.svg";